export const googlePLay = (
  <svg
    width="24"
    height="26"
    viewBox="0 0 24 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.34536 0.533641C1.05727 0.845361 0.890869 1.32167 0.890869 1.94511V24.0573C0.890869 24.6808 1.05727 25.1571 1.35529 25.4563L1.43228 25.5237L13.7705 13.1346V12.8578L1.42235 0.466309L1.34536 0.533641Z"
      fill="url(#paint0_linear)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.8757 17.2768L13.7604 13.1446V12.8554L17.8757 8.72319L17.9651 8.77805L22.8328 11.5561C24.2261 12.3441 24.2261 13.6459 22.8328 14.4439L17.9651 17.2219L17.8757 17.2768Z"
      fill="url(#paint1_linear)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.9651 17.2219L13.7605 13L1.34528 25.4663C1.79976 25.9551 2.56221 26.01 3.41406 25.5337L17.9651 17.2219Z"
      fill="url(#paint2_linear)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.9651 8.77805L3.41406 0.478801C2.56221 -0.00997704 1.79728 0.0573549 1.34528 0.546133L13.7605 13L17.9651 8.77805Z"
      fill="url(#paint3_linear)"
    />
    <path
      opacity="0.2"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.8757 17.1322L3.42396 25.3766C2.61681 25.8429 1.89658 25.8105 1.43215 25.3866L1.35516 25.4639L1.43215 25.5312C1.89658 25.9527 2.61681 25.9876 3.42396 25.5212L17.9751 17.222L17.8757 17.1322Z"
      fill="black"
    />
    <path
      opacity="0.12"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.8329 14.2993L17.8633 17.1322L17.9527 17.2219L22.8205 14.4439C23.5183 14.0449 23.8611 13.5212 23.8611 13C23.8189 13.4788 23.4637 13.9327 22.8329 14.2993Z"
      fill="black"
    />
    <path
      opacity="0.25"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.41414 0.623478L22.8329 11.7008C23.4637 12.0574 23.8189 12.5237 23.8735 13C23.8735 12.4788 23.5308 11.9551 22.8329 11.5561L3.41414 0.478839C2.02088 -0.32166 0.890869 0.34667 0.890869 1.94517V2.08981C0.890869 0.488814 2.02088 -0.167046 3.41414 0.623478Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="12.6638"
        y1="1.70654"
        x2="-7.11064"
        y2="6.95384"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00A0FF" />
        <stop offset="0.00657" stopColor="#00A1FF" />
        <stop offset="0.2601" stopColor="#00BEFF" />
        <stop offset="0.5122" stopColor="#00D2FF" />
        <stop offset="0.7604" stopColor="#00DFFF" />
        <stop offset="1" stopColor="#00E3FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="24.6498"
        y1="13"
        x2="0.552055"
        y2="13"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE000" />
        <stop offset="0.4087" stopColor="#FFBD00" />
        <stop offset="0.7754" stopColor="#FFA500" />
        <stop offset="1" stopColor="#FF9C00" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="15.6788"
        y1="15.2973"
        x2="-0.28399"
        y2="42.0538"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF3A44" />
        <stop offset="1" stopColor="#C31162" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="-1.78101"
        y1="-6.82121"
        x2="5.34065"
        y2="5.12868"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#32A071" />
        <stop offset="0.0685" stopColor="#2DA771" />
        <stop offset="0.4762" stopColor="#15CF74" />
        <stop offset="0.8009" stopColor="#06E775" />
        <stop offset="1" stopColor="#00F076" />
      </linearGradient>
    </defs>
  </svg>
);
